import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Table, Modal, Toast } from 'react-bootstrap'
import { WithdrawalRequestModal } from './WithdrawalModal'
import {
  getUserPurchaseHistoryAsync,
  getCurrentSlotAsync,
  getBaseGramPriceAsync,
  setWithdrawRequestAsync,
  setWithdrawBatchNumber,
  getWithdrawSettingsAsync,
} from '../smartContract'
import { getErcContract } from '../../../utils'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import BasicPagination from '../pagination/BasicPagination'
import { Link } from 'react-router-dom'
import { userProfileInfoAsync } from '../Auth/_redux'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.2) !important',
  },
}))

function Withdrawal() {
  const classes = useStyles()

  const [WithdrawalDetailsModal, setWithdrawalDetailsModal] = useState(false)
  const handleClose = () => setWithdrawalDetailsModal(false)
  const handleShow = () => setWithdrawalDetailsModal(true)
  ////
  const [RequestWithdrawModal, setRequestWithdrawModal] = useState(false)
  const handleClose1 = () => setRequestWithdrawModal(false)
  const handleShow1 = () => setRequestWithdrawModal(true)
  ///
  const [selected, setSelected] = useState({})

  const [status, setStatus] = useState('')

  const { web3, connected, chainId, address } = useSelector(
    (state) => state.etherium,
    shallowEqual,
  )
  const {
    backdrop,
    currentSlots,
    increasePrice,
    withdrawSlots,
    WithdrawBatch,
    WithdrawLimit,
    withdrawSettings,
  } = useSelector((state) => state.stake, shallowEqual)

  const dispatch = useDispatch()

  useEffect(() => {
    if (connected && !currentSlots.Gram) {
      let ercCntrct = getErcContract(chainId, web3)
      dispatch(getCurrentSlotAsync(ercCntrct, address))
    }
  }, [connected])

  useEffect(() => {
    if (connected) {
      let ercCntrct = getErcContract(chainId, web3)
      dispatch(
        getUserPurchaseHistoryAsync(
          ercCntrct,
          address,
          web3,
          WithdrawBatch,
          WithdrawLimit,
          status,
        ),
      )
    }
  }, [connected])

  const onWithdrawRequest = (data) => {
    console.log(data)
    let finalData = {
      tokens: data.tokens,
      grams: data.slot.grams,
      amount: data.price,
      address: address,
      perGramPrice: increasePrice,
      goldPartID: data.slot.goldPartID,
      requestTransferMehtod: data.requestTransferMehtod,
      withdrawCharges: withdrawSettings,
      slot: data.slot,
    }
    dispatch(setWithdrawRequestAsync(finalData, handleClose1))
  }

  const onSelectSlot = (slot) => {
    setSelected(slot)
    handleShow(true)
  }

  const onStatusChange = (e) => {
    let status = e.target.value
    setStatus(status)
    let ercCntrct = getErcContract(chainId, web3)
    dispatch(
      getUserPurchaseHistoryAsync(
        ercCntrct,
        address,
        web3,
        WithdrawBatch,
        WithdrawLimit,
        status,
      ),
    )
  }

  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : WithdrawBatch
    dispatch(setWithdrawBatchNumber(count))
    let ercCntrct = getErcContract(chainId, web3)
    dispatch(
      getUserPurchaseHistoryAsync(
        ercCntrct,
        address,
        web3,
        count,
        WithdrawLimit,
        status,
      ),
    )
  }

  const { user } = useSelector((state) => state.auth, shallowEqual)

  useEffect(() => {
    // dispatch(getBaseGramPriceAsync())
    dispatch(getWithdrawSettingsAsync())
    dispatch(userProfileInfoAsync(user._id))
  }, [])

  const [showA, setShowA] = useState(true)
  const toggleShowA = () => setShowA(!showA)

  return (
    <>
      <div className="row">
        {/* message pop up for KYC link begins*/}
        {user.kycStatus !== 'COMPLETED' ? (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  Your KYC is not completed. Please complete it{' '}
                  <Link to="/kyc">
                    <span className="text-dark kyc-toast-title-link">here</span>{' '}
                  </Link>{' '}
                  in order to be able to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        ) : (
          <div className="col-md-12 d-flex justify-content-center">
            <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
              <Toast.Body>
                <h2 className="kyc-toast-title">
                  {' '}
                  Click{' '}
                  <a
                    href={`http://rfid.victoreanum.com/?uid=${user._id}`}
                    target="_blank"
                  >
                    here
                  </a>{' '}
                  to buy gold.{' '}
                </h2>
              </Toast.Body>
            </Toast>
          </div>
        )}
        {/* message pop up for KYC link ends*/}

        <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap db_1400">
          <div className="mr-1">
            <h5 className="inpg_ttl mr-5">Withdrawal</h5>
          </div>
          {/* <button
            type="button"
            className="btn btn-def btn-defv4 btntkt"
            onClick={handleShow1}
          >
            Request withdraw
          </button> */}
          <Link
            to="withdrawal/withdraw-request"
            className="btn btn-def btn-defv4 btntkt"
          >
            Request withdraw
          </Link>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <form className="subheader_filter">
              <div className="form-row">
                <div className="form-group mb-1">
                  <select
                    className="form-control wtblcar_v2"
                    value={status}
                    onChange={onStatusChange}
                  >
                    <option value="">Status</option>
                    <option value="PENDING">PENDING</option>
                    <option value="ACCEPTED">ACCEPTED</option>
                    <option value="REJECTED">REJECTED</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn">
            <div className="tblmrgn mt-0">
              <Table
                hover
                responsive
                className="mb-0 default_table mrpdng_tbl with_hoverbtn"
              >
                <thead>
                  <tr>
                    <th className="wd-120">Date and Time</th>
                    <th>Transaction ID</th>
                    <th>Withdraw Amount (USD)</th>
                    <th>Tokens</th>
                    <th>Grams</th>
                    <th>Payment By</th>
                    <th>Status</th>
                    <th className="wd-120"></th>
                  </tr>
                </thead>
                <tbody>
                  {withdrawSlots.withdrawList.length ? (
                    withdrawSlots.withdrawList.map((slot) => (
                      <tr key={slot._id}>
                        <td>{new Date(slot.createdAt).toLocaleString()}</td>
                        <td>{slot.TransactionId}</td>
                        <td>{parseFloat(slot.amount).toFixed(4)}</td>
                        <td>{slot.tokens}</td>
                        <td>{slot.grams}</td>
                        <td>{slot.requestTransferMehtod}</td>
                        <td className="pngng_stt">{slot.status}</td>
                        <td>
                          <button
                            type="button"
                            onClick={() => onSelectSlot(slot)}
                            className="btn_new btn-sm dtld_btn"
                          >
                            Details
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <div className="row d-flex align-items-center mr-5 ml-5 mt-5">
                <div className="col-md-4 mb-5 fn_s_16 f-w-400">
                  Displaying {WithdrawBatch * WithdrawLimit + 1} -{' '}
                  {WithdrawBatch * WithdrawLimit + WithdrawLimit} of{' '}
                  {withdrawSlots.totalRecords} Records
                </div>
                <div className="col-md-4 text-center mb-5 algnlft676"></div>
                <div className="col-md-4 text-right mb-5 aspgntn">
                  <BasicPagination
                    totalRecords={withdrawSlots.totalRecords}
                    limit={WithdrawLimit}
                    batch={WithdrawBatch + 1}
                    onBatchChange={onPageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={WithdrawalDetailsModal}
        onHide={handleClose}
        centered
        className="def_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Withdrawal Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form def_form frmwtpddng">
            <div className="row">
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Date and Time
                </label>
                <h4 className="fn_s_20 f-w-500 color_blk">
                  {new Date(selected.createdAt).toLocaleString()}
                </h4>
              </div>
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Status
                </label>
                <h4 className="fn_s_20 f-w-500 pngng_stt">{selected.status}</h4>
              </div>
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Transaction ID
                </label>
                <h4 className="fn_s_20 f-w-500 pngng_stt">
                  {selected.TransactionId}
                </h4>
              </div>
              {/* <div className="col-xl-6 col-sm-6 mb-5">
                                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">Withdraw ID</label>
                                <h4 className="fn_s_20 f-w-500 color_blk">{selected.}</h4>
                            </div> */}
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Withdraw Amount (USD)
                </label>
                <h4 className="fn_s_20 f-w-500 color_blk">
                  {parseFloat(selected.amount).toFixed(4)}
                </h4>
              </div>
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Payment By
                </label>
                <h4 className="fn_s_20 f-w-500 color_blk">
                  {selected.requestTransferMehtod}
                </h4>
              </div>
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Tokens
                </label>
                <h4 className="fn_s_20 f-w-500 color_blk">{selected.tokens}</h4>
              </div>
              <div className="col-xl-6 col-sm-6 mb-5">
                <label className="fn_s_14 f-w-400 color_blk opacity50 mb-0">
                  Grams
                </label>
                <h4 className="fn_s_20 f-w-500 color_blk">{selected.grams}</h4>
              </div>
              <div className="col-md-12 mt-5 text-center">
                <button type="submit" className="btn btn-def btn-defv4 btnwtic">
                  download
                  <span className="material-icons">download</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <WithdrawalRequestModal
        RequestWithdrawModal={RequestWithdrawModal}
        handleClose1={handleClose1}
        withdrawSlots={withdrawSlots}
        increasePrice={increasePrice}
        currentSlots={currentSlots}
        onWithdrawRequest={onWithdrawRequest}
        withdrawSettings={withdrawSettings}
      />
      <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  )
}

export default Withdrawal
